import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
} from "@mui/material";
import "../Signup/Signup.css"
import { DynamicToastContent } from "../Toast/CommonToast";
import { toast } from "react-toastify";
import messageLogo from "../../assets/Message.png";
import { forgotPasswordRes } from "../../services/apiService";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ForgotPass: React.FC = () => {
  const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
    });
    const [loginError, setLoginError] = useState(""); 

    const [formErrors, setFormErrors] = useState({
        email: "",
    });


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validateForm = () => {
        const errors = { ...formErrors };
        let isValid = true;

        // Validate email
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!formData.email) {
            errors.email = "Email is required";
            isValid = false;
        } else if (!emailRegex.test(formData.email)) {
            errors.email = "Invalid email format";
            isValid = false;
        } else {
            errors.email = "";
        }

    setFormErrors(errors);
    return isValid;
  };

  const handleOnSubmit = async (e: any) => {
    setLoginError("");
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    try {
      const apiresponse = await forgotPasswordRes({ email: formData.email });
      if (apiresponse?.status === "true") {
        navigate('/reset-password');

        const toastContent = (
          <DynamicToastContent
            icon={messageLogo}
            message="An email has been sent for password recovery."
          />
        );
        toast(toastContent, {
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        });
      }
      else{
        setLoginError(apiresponse?.message || "An error occurred. Please try again.");
        toast.error(apiresponse?.message,{
          autoClose: 10000
        });
      }
    } catch (error:any) {
      setLoginError(error?.message || "An error occurred. Please try again.");
      console.error("Error sending forgot password request:", error);
      toast.error(
        error?.message,{
          autoClose: 10000
        }
      );
    }
  };

    return (
        <Box className="maincontainer">
            {/* Background Image */}
            <Box className="imagecontainer">
            {/* <img
                    src={desktop ? 'https://showcasaai.blob.core.windows.net/applicationasset/1920_Image.svg':'https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg'}
                    alt="Background"
                    style={{ width: "100%",objectFit: "cover", height: '100%' }}
                /> */}
            </Box>

            {/* Form Container */}
            <Box className="leftcontainer">
                <Box sx={{ maxWidth: 350, width: "100%" }}>
                    {/* Logo and Title */}
                    <Box sx={{ textAlign: "left", marginBottom: 3 }}>
                        <img
                            src={'/assets/showcasaNew.svg'}
                            alt="Logo"
                            className="showcasalogo"
                        />
                    </Box>
                     <Box display="flex" alignItems="center" gap={1} sx={{width: '100%'}}>
                    <ArrowBackIcon style={{ cursor: 'pointer' }} onClick={() => navigate('/signin')} />
                    <Typography variant="body1" align="center" className='forgot-verify'>Forgot password</Typography>
                </Box>

                    <form onSubmit={handleOnSubmit} className="form">
                        <TextField
                            label="Email Address"
                            variant="outlined"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            error={Boolean(formErrors.email)}
                            helperText={formErrors.email}
                            fullWidth
                            margin="normal"
                           className="textField"
                        />
                             {loginError && (
                                                  <Typography color="error" sx={{  textAlign: 'left' }} className='errorText'>
                                                    {loginError}
                                                  </Typography>
                                                )}

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              className="submitButton"
              onClick={handleOnSubmit}
              sx={{ marginTop: 2 }}
            >
              Continue
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPass;
